import { helper as buildHelper } from '@ember/component/helper';

export default buildHelper(([fn, ...args]) => fn(...args));
